// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__oH8yA","label":"Section_label__3L-x-","contentWrap":"Section_contentWrap__38LGP","footer":"Section_footer__do3yJ","footerInner":"Section_footerInner__3Tx2e"};